import { service } from '@/utils/request'

export default {
  // 查询
  getList(pageIndex, pageSize, data) {
    return service({
      url: `/cloud/uac/vipCardType/pages?pageIndex=${pageIndex}&pageSize=${pageSize}`,
      method: 'post',
      data
    })
  },
  // 创建 / 编辑
  save(data) {
    return service({
      url: '/cloud/uac/vipCardType/save',
      method: 'post',
      data: data
    })
  },
  // 修改状态
  changeStatus(data) {
    return service({
      url: '/cloud/uac/vipCardType/status',
      method: 'post',
      data: data
    })
  },
  // 详情
  detail(id) {
    return service({
      url: '/cloud/uac/vipCardType/detail/' + id,
      method: 'get'
    })
  },
  // 删除
  delete(id) {
    return service({
      url: '/cloud/uac/vipCardType/del/' + id,
      method: 'get'
    })
  },
  // 查询学科与栏目
  columnBindSubject() {
    return service({
      url: '/cloud/uac/vipCardType/beforeSave',
      method: 'get'
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/operateManage/vipType.js